const oneBtcInSatoshiCal = 100000000;

function handleInputTypeChangeFrom(event) {
    const from = document.getElementById('satscalfrom').value;
    const to = document.getElementById('satscalto').value
    //console.log("handleInputTypeChangeFrom", from, to);
    calculateSats(true);
}


function handleInputTypeChangeTo(event) {
    const from = document.getElementById('satscalfrom').value;
    const to = document.getElementById('satscalto').value
    //console.log("handleInputTypeChangeTo", to, from);
    calculateSats(false);
}

function calculateSats(straight) {
    let currency = 'EUR';
    const from = document.getElementById('satscalfrom').value;
    const to = document.getElementById('satscalto').value
    if (from === 'EUR' || to === 'EUR') {
        currency = 'EUR'
    }
    if (from === 'USD' || to === 'USD') {
        currency = 'USD'
    }
    let flow = '';
    if (straight) {
        flow = from + to
    } else {
        flow = to + from
    }
    //console.log("FLOW", flow)
    let amountFrom = document.getElementById('satscal-input-value-from').value;
    let amountTo = document.getElementById('satscal-input-value-to').value;
    //console.log("AMOUNTS", amountFrom, amountTo)
    let btcPricesCal = JSON.parse(localStorage.btcprices);
    let btcPriceItemCal = btcPricesCal.data.find(item => item.code === currency)
    //console.log("btcPriceItem: ", btcPriceItemCal)
    /* 1 BTC in Satoshi / Current BTC Price in Cent = Satoshi per cent */
    let satoshiPerCentCal = oneBtcInSatoshi / (btcPriceItemCal.rate * 100)
    //console.log("satoshiPerCent: ", satoshiPerCentCal)
    /* EUR USD DIFF */
    let btcPriceUsd = btcPricesCal.data.find(item => item.code === 'USD').rate
    let btcPriceEur = btcPricesCal.data.find(item => item.code === 'EUR').rate
    let usdEurDiff = btcPriceUsd / btcPriceEur
    //console.log(btcPriceUsd, btcPriceEur, usdEurDiff)
    switch (flow) {
        case "SATSSATS":
        case "BTCBTC":
        case "EUREUR":
            if (straight) {
                document.getElementById('satscal-input-value-from').value = amountFrom;
                document.getElementById('satscal-input-value-to').value = amountFrom;
            } else {
                document.getElementById('satscal-input-value-from').value = amountTo;
                document.getElementById('satscal-input-value-to').value = amountTo;
            }
            break;
        case "EURUSD":
            if (straight) {
                let calculatedValueEurToUsdR = (amountFrom * usdEurDiff).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurToUsdR;
            } else {
                let calculatedValueEurToUsd = (amountTo * usdEurDiff).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurToUsd;
            }
            break;
        case "USDEUR":
            if (straight) {
                let calculatedValueEurToUsdR = (amountFrom / usdEurDiff).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurToUsdR;
            } else {
                let calculatedValueEurToUsd = (amountTo / usdEurDiff).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurToUsd;
            }
            break;
        case "SATSEUR":
            if (straight) {
                let calculatedValueSatsToEurR = ((amountFrom / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueSatsToEurR;
            } else {
                let calculatedValueSatsToEur = ((amountTo / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueSatsToEur;
            }
            break;
        case "SATSUSD":
            if (straight) {
                let calculatedValueSatsToEurR = ((amountFrom / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueSatsToEurR;
            } else {
                let calculatedValueSatsToEur = ((amountTo / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueSatsToEur;
            }
            break;
        case "SATSBTC":
            if (straight) {
                let calculatedValueSatsToBtcR = (amountFrom / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-to').value = calculatedValueSatsToBtcR;
            } else {
                let calculatedValueSatsToBtc = (amountTo / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-from').value = calculatedValueSatsToBtc;
            }
            break;
        case "BTCEUR":
            if (straight) {
                let calculatedValueBtcToEurR = (((amountFrom * oneBtcInSatoshiCal) / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueBtcToEurR;
            } else {
                let calculatedValueBtcToEur = (((amountTo * oneBtcInSatoshiCal) / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueBtcToEur;
            }
            break;
        case "BTCUSD":
            if (straight) {
                let calculatedValueBtcToEurR = (((amountFrom * oneBtcInSatoshiCal) / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-to').value = calculatedValueBtcToEurR;
            } else {
                let calculatedValueBtcToEur = (((amountTo * oneBtcInSatoshiCal) / satoshiPerCentCal) / 100).toFixed(2);
                document.getElementById('satscal-input-value-from').value = calculatedValueBtcToEur;
            }
            break;
        case "BTCSATS":
            if (straight) {
                let calculatedValueBtcToSatsR = (amountFrom * oneBtcInSatoshiCal).toFixed(0);
                document.getElementById('satscal-input-value-to').value = calculatedValueBtcToSatsR;
            } else {
                let calculatedValueBtcToSats = (amountTo * oneBtcInSatoshiCal).toFixed(0);
                document.getElementById('satscal-input-value-from').value = calculatedValueBtcToSats;
            }
            break;
        case "EURSATS":
            if (straight) {
                let calculatedValueEurFromSatsR = ((amountFrom * 100) * satoshiPerCentCal).toFixed(0);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurFromSatsR;
            } else {
                let calculatedValueEurFromSats = ((amountTo * 100) * satoshiPerCentCal).toFixed(0);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurFromSats;
            }
            break;
        case "EURBTC":
            if (straight) {
                let calculatedValueEurFromBtcR = (((amountFrom * 100) * satoshiPerCentCal) / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurFromBtcR;
            } else {
                let calculatedValueEurFromBtc = (((amountTo * 100) * satoshiPerCentCal) / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurFromBtc;
            }
            break;
        case "USDSATS":
            if (straight) {
                let calculatedValueEurFromSatsR = ((amountFrom * 100) * satoshiPerCentCal).toFixed(0);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurFromSatsR;
            } else {
                let calculatedValueEurFromSats = ((amountTo * 100) * satoshiPerCentCal).toFixed(0);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurFromSats;
            }
            break;
        case "USDBTC":
            if (straight) {
                let calculatedValueEurFromBtcR = (((amountFrom * 100) * satoshiPerCentCal) / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-to').value = calculatedValueEurFromBtcR;
            } else {
                let calculatedValueEurFromBtc = (((amountTo * 100) * satoshiPerCentCal) / oneBtcInSatoshiCal).toFixed(8);
                document.getElementById('satscal-input-value-from').value = calculatedValueEurFromBtc;
            }
            break;
        default:
            document.getElementById('satscal-input-value-from').value = 0;
            document.getElementById('satscal-input-value-to').value = 0;
            break;
    }
}

function handleSliderChangeSatsCalFrom(event) {
    event.preventDefault();
    const root = event.target.closest('.satscal-form-from');
    const el = root.querySelector('.satscal-input-value-from');
    const price = parseInt(el.value);
    const min = parseInt(event.target.getAttribute('min'));
    const max = parseInt(event.target.getAttribute('max'));
    if (price < min) {
        el.value = min;
    } else if (price > max) {
        el.value = max;
    }
    root.querySelector('.satscal-input-range').value = el.value;
    calculateSats(true);
}

function handleSliderInputSatsCalFrom(event) {
    event.target.closest('.satscal-form-from').querySelector('.satscal-input-value-from').value = event.target.value;
    calculateSats(true);
}

function handleInputSatsCalFrom(event) {
    event.preventDefault();
    const root = event.target.closest('.satscal-form-from');
    const satscalamountfrom = parseInt(event.target.dataset.satscalamountfrom);
    if (isNaN(event.target.value)) root.querySelector('.satscal-input-value-from').value = satscalamountfrom;
    const min = parseInt(event.target.getAttribute('min'));
    const max = parseInt(event.target.getAttribute('max'));
    if (event.target.value < min) {
        event.target.value = min;
    } else if (event.target.value > max) {
        event.target.value = max;
    }
    calculateSats(true);
}


function handleSliderChangeSatsCalTo(event) {
    event.preventDefault();
    const root = event.target.closest('.satscal-form-to');
    const el = root.querySelector('.satscal-input-value-to');
    const price = parseInt(el.value);
    const min = parseInt(event.target.getAttribute('min'));
    const max = parseInt(event.target.getAttribute('max'));
    if (price < min) {
        el.value = min;
    } else if (price > max) {
        el.value = max;
    }
    root.querySelector('.satscal-input-range').value = el.value;
    calculateSats(false);
}

function handleSliderInputSatsCalTo(event) {
    event.target.closest('.satscal-form-to').querySelector('.satscal-input-value-to').value = event.target.value;
    calculateSats(false);
}

function handleInputSatsCalTo(event) {
    event.preventDefault();
    const root = event.target.closest('.satscal-form-to');
    const satscalamountto = parseInt(event.target.dataset.satscalamountto);
    if (isNaN(event.target.value)) root.querySelector('.satscal-input-value-to').value = satscalamountto;
    const min = parseInt(event.target.getAttribute('min'));
    const max = parseInt(event.target.getAttribute('max'));
    if (event.target.value < min) {
        event.target.value = min;
    } else if (event.target.value > max) {
        event.target.value = max;
    }
    calculateSats(false);
}
